/*!
 Leaflet plugin to customize the zoom control
 (c) 2012-2018 Andxor soluzioni informatiche <http://www.andxor.it/>
*/

import { Zoom } from 'leaflet/src/control/Control.Zoom';
import * as DomUtil from 'leaflet/src/dom/DomUtil';
import * as Doc from 'doc';

export var MyZoom = Zoom.extend({
    onAdd: function () {
        var className = 'leaflet-control-zoom',
            container = DomUtil.create('div', className + ' leaflet-bar');

        this._createButton('', 'Zoom in', className + '-in', container, this._zoomIn);
        this._createButton('', 'Zoom out', className + '-out', container, this._zoomOut);
        this._createButton('', 'Fit width', className + '-width', container, this._zoomWidth);
        this._createButton('', 'Fit page', className + '-page', container, this._zoomPage);

        return container;
    },

    _zoomIn: function (e) {
        if (this._map._zoom < this._map.getMaxZoom())
            this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
    },

    _zoomOut: function (e) {
        if (this._map._zoom > this._map.getMinZoom())
            this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
    },

    _zoomWidth: function () {
        Doc.fitWidth();
    },

    _zoomPage: function () {
        Doc.fitPage();
    }
});
